/* Bascule de theme au scroll, façon porsche.com.
   Chaque section porte data-section-theme="clair" ou "sombre". Des qu'une
   section franchit le milieu de l'ecran, son theme est applique a <html> et
   toutes les couleurs du site suivent. Le fondu vient des transitions CSS sur
   background-color et color : on ne transitionne pas les variables elles-memes.

   Plusieurs sections chargent ce fichier ; le garde-fou evite d'installer
   autant d'observateurs qu'il y a de sections sur la page. */
(function () {
  if (window.__skydriftTheme) return;
  window.__skydriftTheme = true;

  const racine = document.documentElement;
  // Parametres du theme > SkyDrift > Ambiance : en sombre ou clair, le fond
  // est pose par le layout et ne bouge plus. Seul « alternee » bascule.
  if (racine.dataset.ambiance && racine.dataset.ambiance !== "alternee") return;
  const sections = document.querySelectorAll("[data-section-theme]");
  if (!sections.length) return;

  let courant = null;
  const applique = t => {
    if (t === courant) return;
    courant = t;
    if (t === "clair") {
      racine.setAttribute("data-theme", "clair");
      racine.style.colorScheme = "light";       // pour les controles natifs
    } else {
      racine.removeAttribute("data-theme");
      racine.style.colorScheme = "dark";
    }
  };

  // une ligne au milieu de l'ecran : la section qui la croise impose son theme
  const observateur = new IntersectionObserver(entrees => {
    entrees.forEach(e => {
      if (e.isIntersecting) applique(e.target.dataset.sectionTheme);
    });
  }, { rootMargin: "-50% 0px -50% 0px", threshold: 0 });

  sections.forEach(s => observateur.observe(s));

  // sans animation demandee, on bascule sec plutot que de tout figer
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    racine.style.setProperty("--duree-theme", "0ms");
  }
})();
